<template>
  <section class="ion-padding-vertical">
    <div class="home-section-container ion-padding">
      <div class="cta-card ion-padding">
        <!-- Pattern Overlay -->
        <div class="pattern-overlay"></div>

        <div class="cta-content ion-text-center">
          <ion-chip color="light">
            <ion-icon aria-hidden="true" :icon="sparklesOutline" />
            <ion-label>{{ $t("home.cta.badge") }}</ion-label>
          </ion-chip>

          <h2 class="cta-title ion-margin-top ion-margin-bottom">
            <ion-text color="light">
              {{ $t("home.cta.title") }}
            </ion-text>
          </h2>

          <ion-text color="light" class="cta-description ion-margin-bottom">
            {{ $t("home.cta.description") }}
          </ion-text>

          <div class="ion-margin-bottom">
            <ion-button size="large" color="light" @click="startPlaying">
              {{ $t("home.cta.createAccount") }}
              <ion-icon aria-hidden="true" slot="end" :icon="arrowForward" />
            </ion-button>
          </div>

          <ion-text color="light" class="cta-footer">
            {{ $t("home.cta.footer") }}
          </ion-text>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { IonButton, IonChip, IonIcon, IonLabel, IonText } from "@ionic/vue";
import { sparklesOutline, arrowForward } from "ionicons/icons";
import { useAuthCta } from "@/composables/useAuthCta";

const { startPlaying } = useAuthCta();
</script>

<style scoped src="src/components/homePage/home-page.css"></style>
<style scoped>
.cta-card {
  position: relative;
  border-radius: 1.5rem;
  background: var(--gradient-hero);
  overflow: hidden;
  --ion-padding: 3rem;
}

.pattern-overlay {
  position: absolute;
  inset: 0;
  opacity: 0.1;
  background-image: url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%23ffffff' fill-opacity='1' fill-rule='evenodd'%3E%3Cpath d='M0 40L40 0H20L0 20M40 40V20L20 40'/%3E%3C/g%3E%3C/svg%3E");
}

.cta-content {
  position: relative;
}

.cta-title {
  font-size: clamp(1.875rem, 5vw, 3rem);
}

.cta-description {
  font-size: clamp(1rem, 2vw, 1.25rem);
}

.cta-footer {
  font-size: 0.875rem;
}
</style>
